import { ClientAnalytics } from './clientAnalytics'

export type WorkspaceSettingsOpenSource = 'shortcut' | 'header_button' | 'header_shortcuts_button'

// ── Dialog lifecycle ──
type LifecycleEvent =
  | 'workspace_settings:open'
  | 'workspace_settings:close'
  | 'workspace_settings:nav'

// ── Challenge panel (per-challenge) ──
type ChallengeEvent =
  | 'workspace_settings:challenge:weapon_change'

// ── Appearance panel (cross-challenge) ──
type AppearanceEvent =
  | 'workspace_settings:appearance:font_size_change'
  | 'workspace_settings:appearance:theme_change'
  | 'workspace_settings:appearance:tab_style_change'

// ── Behavior panel (cross-challenge) ──
type BehaviorEvent =
  | 'workspace_settings:behavior:autosave_indicator_toggle'
  | 'workspace_settings:behavior:confirm_tab_close_toggle'
  | 'workspace_settings:behavior:wrap_selection_brackets_toggle'
  | 'workspace_settings:behavior:wrap_selection_quotes_toggle'

// ── Python panel (cross-challenge) ──
type PythonEvent =
  | 'workspace_settings:python:toggle_button'

export type WorkspaceSettingsAnalyticsEvent =
  | LifecycleEvent
  | ChallengeEvent
  | AppearanceEvent
  | BehaviorEvent
  | PythonEvent

interface WorkspaceSettingsOpenProperties {
  source: WorkspaceSettingsOpenSource
  challengeId?: string
  taskId?: string
}

export function trackWorkspaceSettings(event: 'workspace_settings:open', properties: WorkspaceSettingsOpenProperties): void
export function trackWorkspaceSettings(event: Exclude<WorkspaceSettingsAnalyticsEvent, 'workspace_settings:open'>, properties?: Record<string, unknown>): void
export function trackWorkspaceSettings(
  event: WorkspaceSettingsAnalyticsEvent,
  properties?: WorkspaceSettingsOpenProperties | Record<string, unknown>
) {
  ClientAnalytics.track(event, properties as Record<string, unknown> | undefined)
}
